import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actions from "../../actions";
import styles from "./Chat.module.css"; // Assuming you create a CSS module file for styling
import { io } from "socket.io-client";
import OutiftEditor from "../../components/OutfitEditor/OutfitEditor";

const Chat = ({ startLoadingRequest, stopLoadingRequest }) => {
  const [users, setUsers] = useState([]);
  const [pendingMessageCount, setPendingMessageCount] = useState(0)
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [selectUser, setSelectUser] = useState(null);
  const [media, setMedia] = useState([]);
  const [socket, setSocket] = useState(null);
  const [userid, setUserid] = useState(null);
  const [wordrobItem, setWordrobItem] = useState([])
  const [outfitItem, setOutfitItem] = useState([])
  const [createOutfit, setCreateOutfit] = useState(false)
  //Modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState([]);
  const [wardrobeData,setWardrobeData]= useState([])
  const messagesEndRef = useRef(null);


  useEffect(() => {
    stopLoadingRequest();

    // Fetch user details from localStorage once and set userid
    const userDetails = localStorage.getItem("userDetails");
    if (userDetails) {
      const user_id = JSON.parse(userDetails)._id;
      setUserid(user_id);
    }
  }, []);
  useEffect(() => {
    // Scroll to bottom when messages change
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  const handleSendMessage = () => {
    // console.log("hit send", selectUser);
    // console.log(message);

    const userDetails = localStorage.getItem("userDetails");

    if (userDetails) {
      // console.log(userDetails, "11111");
      const user_id = JSON.parse(userDetails)._id;
      const senderId = user_id;
      const receiverId = selectUser.userId._id;
      const roomId = `${user_id}_${receiverId}`;
      const senderType="admin"
// console.log({message, senderId, receiverId, roomId, media})
      // if (socket && selectedUser) {
      socket.emit("send_message", {message, senderId, receiverId, roomId, media,senderType});
      setMessage("");

      // }
    }
  };

  const loadChat = (user) => {
    const userDetails = localStorage.getItem("userDetails");
    const user_id = JSON.parse(userDetails);
    // setUserid(user_id._id);
    // console.log(user);
    const senderId = user_id?._id;
    const receiverId = user?.userId?._id;
    if (socket) {
      socket.emit("joinAdminRoom", senderId, receiverId);
      socket.emit("loadAdminChat", senderId, receiverId);
    }
  };

  // useEffect(() => {
  //   const userDetails = localStorage.getItem("userDetails");
  //   const user_id = JSON.parse(userDetails);
  //   const fetchUser = async () => {
  //     const response = await getAllCoach(user_id._id);
  //     console.log(response);
  //     setUsers(response?.data?.data);
  //     console.log(response);
  //   };
  //   fetchUser();
  // }, []);

  useEffect(() => {
    // const URL =  "ws://localhost:10042" 
    const URL =  "wss://dev-api.ponderiee.com"  
    const newSocket = io(URL, {
      extraHeaders: { "ngrok-skip-browser-warning": "any-value" },
    });

    newSocket.on("connect", () => {
      setSocket(newSocket);
    });

    return () => {
      if (newSocket) {
        newSocket.disconnect();
      }
    };
  }, []);

  const loadUserData = (item) => {
     setUsers(item);
    let data = item.filter((user) => user?.seenCount > 0 && user?.isChatOpen == true).length
    setPendingMessageCount(data)


  }

  useEffect(() => {
    const userDetails = localStorage.getItem("userDetails");
    const user_id = JSON.parse(userDetails);
    // console.log(user_id?._id, "2222");

    if (!socket) return;
    // socket.emit("loadAdminUsers", user_id?._id);

    // const handleLoadAdminUsers = (item) => {
    //   console.log(item);
    //   //   setUsers(item);
    // };


    const handleAdminMessageReceived = (item) => {
      setMessages((prevMessages) => [...prevMessages, item]);
    };

    const handleLoadAdminChat = (item) => {
      // console.log(item);
      setMessages(item);
    };

    socket.emit("loadUsers", user_id?._id)
    socket.on("message_received", handleAdminMessageReceived);
    socket.on("loadAdminChat", handleLoadAdminChat);
    socket.on("loadUsers", loadUserData)
    // console.log("selectUser",selectUser?.userId?._id)
    // socket.on('join_room',{senderId:selectUser })

    socket.on("error",(err)=>{console.log(err)})

    return () => {
      socket.off("message_received", handleAdminMessageReceived);
      socket.off("loadAdminChat", handleLoadAdminChat);
    };
  }, [socket]);

  const renderOptions = (options) => {
    return (
      <div className={styles.optionsContainer}>
        {options.map((option, index) => (
          <button key={index} className={styles.optionButton}>
            {option}
          </button>
        ))}
      </div>
    );
  };
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const handleClickOutside = (event) => {
    if (!event.target.closest('.dropdownContainer')) {
      setDropdownVisible(false);
    }
  };
  // console.log(dropdownVisible,"dropdownVisible")
  // To close dropdown on click outside
  // useEffect(() => {
  //   document.addEventListener('click', handleClickOutside);
  //   return () => {
  //     document.removeEventListener('click', handleClickOutside);
  //   };
  // }, []);

  async function selectingUser(user) {
    // console.log("user",user)
    setSelectUser(user);

 socket.emit('join_room',{senderId:user?.userId?._id ,type:"admin"})

    // let userData = await 
    // let data = await getUserById(user?.userId?._id)
    // let userData = data?.data?.data
    // setWordrobItem(userData.waredrob)
    // setOutfitItem(userData?.outfits)
    loadChat(user);
    socket.emit("isSeen", user?.userId?._id)
    const userDetails = localStorage.getItem("userDetails");
    const user_id = JSON.parse(userDetails);


    socket.emit("loadUsers", user_id?._id)

    socket.on("loadUsers", loadUserData)
  }

  const openModal = (type) => {
    setIsModalOpen(true);
    if (type === "wardrobe") {
      setModalContent(wordrobItem);
    } else if (type === "outfits") {
      setModalContent(outfitItem);
    }
    toggleDropdown()
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent([]);
  };



  function closeChat(user) {
    // console.log(user,"11111")
    const userDetails = localStorage.getItem("userDetails");
    const user_id = JSON.parse(userDetails);

    socket.emit("closeChat", selectUser.userId?._id, user_id?._id)
  }
  const needCanvasBlank = (messages) => {
    return messages==="For which occasion are you looking to style an outfit? Please enter your answer in the chat below."
  }
// console.log("wardrobeData",wardrobeData)
  // Helper function to get latest 'Selected Items' media for a user
  function getLatestSelectedItemsMedia(messages, userId) {
    let outfitMedia = []
    let lastMessage=messages?.length > 0&& messages[messages?.length-1]?.message
    const filtered =messages?.length > 0&&!needCanvasBlank(lastMessage) && messages?.filter(
        (msg) =>
          msg.senderId === userId &&
         ( msg.message === "Selected Items" || msg.message === "Selected Outfits" )&&
          Array.isArray(msg.media) &&
          msg.media.length > 0
      )
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      if(filtered.length > 0&&filtered[0]?.message === "Selected Outfits"){
        const usedItem=filtered[0].usedItemIds
        outfitMedia =wardrobeData?.length>0 && wardrobeData?.filter(item=>usedItem.includes(item._id)).map(i=>i.image)
        return outfitMedia
      }
    return filtered.length > 0 ? filtered[0].media : [];
  }
  function formatTime(dateString) {
  const date = new Date(dateString);
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}
function getFormattedDate(date) {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  if (date.toDateString() === today.toDateString()) return "Today";
  if (date.toDateString() === yesterday.toDateString()) return "Yesterday";

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

  // console.log("messages",messages)
  // console.log("selected",users)
  return (
    <>
      <div
        className="section chatContainer"
        style={{
          height: "90%",
          padding: "0",
          display: "block",
          overflow: "hidden",
        }}
      >
        {/* <div className="section chatContainer"> */}

        <div style={{ display: "flex", height: "90vh" }}>
          <div className={styles.userList} style={{width:"25%",display:"flex",flexDirection:"column",gap:"5px",alignItems:"start"}}>
            {/* <div className={styles.userList} style={{border:"1px solid red"}}> */}
            {/* Placeholder for users - replace with actual user data */}
            <div
              className="open_chats"
              style={{
                height: "50%",
                width: "100%",
                // overflow: "hidden",
                marginBottom: "2rem",
              }}
            >
              <h3 style={{ display: "flex", justifyContent: "space-between" }}>
                <span className={styles.chatCategory}>Open chats</span>
                {pendingMessageCount ? (
                  <span
                    style={{
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "grey",
                      color: "white",
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                      fontSize: "12px",
                      marginLeft: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    {pendingMessageCount}
                  </span>
                ) : (
                  ""
                )}
              </h3>
              <hr />
              <div
                className="open_chats"
                style={{height:"100%",width:"100%", overflowY: "scroll"}}
              >
                {users?.map(
                  (user, index) =>
                    user?.isChatOpen && (
                      <div
                        key={index}
                        className={styles.userItem}
                        style={{
                          display: "flex",
                          gap: "10px",
                          overflowY: "scroll",
                        }}
                        onClick={() => {
                          // console.log({user})
                          // setSelectUser(user?.userId);
                          selectingUser(user);
                        }}
                      >
                        <div className={styles.avatar}>
                          {user?.userId?.firstName?.charAt(0) ||
                            user?.userId?.username?.charAt(0)}
                        </div>

                        <span style={{ display: "flex", alignItems: "center" }}>
                          {(() => {
                            const name =
                              user?.userId?.firstName ||
                              user?.userId?.username ||
                              "Unknown";

                            return name.length > 10
                              ? name.slice(0, 10) + "..."
                              : name;
                          })()}
                        </span>

                        {user?.seenCount ? (
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              alignItems: "center",
                              backgroundColor: "#25D366",
                              color: "white",
                              borderRadius: "50%",
                              width: "20px",
                              height: "20px",
                              fontSize: "12px",
                              marginLeft: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            {user?.seenCount}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    )
                )}
              </div>
            </div>
            <div
              className="closed_chat"
              style={{
                height: "50%",
                width: "100%",
                // overflow: "hidden",
                marginBottom: "2rem",
              }}
            >
              <h3 className={styles.chatCategory}>Closed chats</h3>
              <hr  />
              <div
                className="closed_chat"
                style={{ height: "100%",width:"100%", overflowY: "scroll" }}
              >
                {users?.map(
                  (user, index) =>
                    !user?.isChatOpen && (
                      <div
                        key={index}
                        className={styles.userItem}
                        style={{ display: "flex", gap: "10px" }}
                        onClick={() => {
                          // setSelectUser(user?.userId);
                          selectingUser(user);
                        }}
                      >
                        <div className={styles.avatar}>
                          {user?.userId?.firstName?.charAt(0)}
                        </div>

                        <span style={{ display: "flex", alignItems: "center" }}>
                          {" "}
                          {user?.userId?.firstName || "no name"}
                        </span>
                      </div>
                    )
                )}
              </div>
            </div>
          </div>
          <div
            className={styles.chatWindow}
            style={{ border: "1px solid green", margin: "0", padding: "0" }}
          >
            {selectUser ? (
              <>
                <div
                  className={styles.chatHeader}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                >
                  <span>
                    Chat with {selectUser.userId.firstName}{" "}
                    {selectUser.userId.lastName}{" "}
                  </span>

                  <div className={styles.dropdownContainer}>
                    <div
                      className={styles.actionButton}
                      onClick={toggleDropdown}
                    >
                      &#x22EE;{" "}
                      {/* Unicode for triple dots (vertical ellipsis) */}
                      {dropdownVisible &&
                        (!selectUser ? (
                          <span
                            className={styles.dropdownMenu}
                            style={{ padding: "1rem", marginTop: "1rem" }}
                          >
                            Please select the user first
                          </span>
                        ) : (
                          <div className={styles.dropdownMenu}>
                            {/* <button
                              className={styles.dropdownItem}
                              onClick={() => openModal("wardrobe")}
                            >
                              View Wardrobe
                            </button>
                            <button
                              className={styles.dropdownItem}
                              onClick={() => openModal("outfits")}
                            >
                              View Outfits
                            </button> */}
                            <button
                              className={styles.dropdownItem}
                              onClick={() => setCreateOutfit(!createOutfit)}
                            >
                              Create Outfit
                            </button>
                            <button
                              className={styles.dropdownItem}
                              onClick={() => closeChat(selectUser)}
                            >
                              Close chat
                            </button>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
                <div className={styles.chatMessages}>
                  {messages.map((chat, index) => {
                    const currentDate = new Date(chat.createdAt);
                    const prevDate =
                      index > 0
                        ? new Date(messages[index - 1].createdAt)
                        : null;

                    const isNewDate =
                      !prevDate ||
                      currentDate.toDateString() !== prevDate.toDateString();

                    const formattedDate = getFormattedDate(currentDate);

                    return (
                      <React.Fragment key={chat._id}>
                        {isNewDate && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              margin: "10px 0",
                              color: "grey",
                              fontSize: "12px",
                              position: "relative",
                              width: "100%",
                            }}
                          >
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                width: "100%",
                                justifyContent: "center",
                              }}
                            >
                              <span
                                style={{
                                  flex: 1,
                                  borderBottom: "1px solid #ddd",
                                  margin: "0 10px",
                                }}
                              />
                              {formattedDate}
                              <span
                                style={{
                                  flex: 1,
                                  borderBottom: "1px solid #ddd",
                                  margin: "0 10px",
                                }}
                              />
                            </span>
                          </div>
                        )}

                        <div
                          className={
                            chat.senderId === userid
                              ? styles.adminMessage
                              : styles.userMessage
                          }
                        >
                          <div>
                            <p
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              {chat.message}
                              <span
                                style={{
                                  fontSize: "10px",
                                  color: "grey",
                                  marginTop: "10px",
                                }}
                              >
                                {formatTime(chat.createdAt)}
                              </span>
                            </p>

                            {chat.senderId === userid &&
                              chat.options &&
                              chat.options.length > 0 &&
                              renderOptions(chat.options)}

                            <div>
                              {chat.media?.map((item, i) => (
                                <div key={i}>
                                  <img
                                    style={{ width: "100%", height: "100%" }}
                                    src={item}
                                    alt=""
                                  />
                                </div>
                              ))}
                              {chat?.adminOutfit?.outfitItem && (
                                <div>
                                  <img
                                    style={{ width: "100%", height: "100%" }}
                                    src={chat?.adminOutfit?.outfitItem}
                                    alt=""
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    );
                  })}
                  <div ref={messagesEndRef} />
                </div>

                {selectUser?.isChatOpen ? (
                  <div className={styles.chatInput}>
                    {/* Chat input box and send button */}
                    <input
                      onChange={(e) => {
                        setMessage(e.target.value); // Update the message state on change
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && message.trim() !== "") {
                          handleSendMessage();
                        }
                      }}
                      value={message} // Bind the input value to the message state
                      type="text"
                      placeholder="Type a message..."
                    />
                    {/* <button onClick={closeTheChat}>Close chat</button> */}
                    <button onClick={handleSendMessage}>Send</button>
                  </div>
                ) : (
                  <div
                    style={{
                      fontSize: "18px",
                      margin: "0 auto",
                      paddingBottom: "10px",
                    }}
                  >
                    Chat is Closed.
                  </div>
                )}
              </>
            ) : (
              <div className={styles.noChatSelected}>
                Select a user to start chatting
              </div>
            )}
          </div>
        </div>
        {isModalOpen && (
          <div className={styles.modalOverlay}>
            <div className={styles.modal}>
              <button className={styles.closeButton} onClick={closeModal}>
                &times;
              </button>
              <div className={styles.modalContent}>
                {modalContent.length > 0 ? (
                  modalContent.map((imageUrl, index) => (
                    <img
                      key={index}
                      src={imageUrl?.image}
                      alt={`Item ${index}`}
                      className={styles.modalImage}
                    />
                  ))
                ) : (
                  <p>No items to display</p>
                )}
              </div>
            </div>
          </div>
        )}

        {createOutfit && (
          <div className={styles.modalOverlay}>
            {
              <OutiftEditor
                stylePrefrence={selectUser.userId.stylePreference}
                userId={selectUser.userId._id}
                socket={socket}
                createOutfit={createOutfit}
                setCreateOutfit={setCreateOutfit}
                setWardrobeData={setWardrobeData}
                // roomId={selectUser.roomId}
                initialImages={getLatestSelectedItemsMedia(
                  messages,
                  selectUser.userId._id
                )}
              />
            }
            {/* {<TestCompo userId = {selectUser.userId._id} socket={socket} createOutfit={createOutfit} setCreateOutfit={setCreateOutfit} roomId={selectUser.roomId}/>} */}
          </div>
        )}
      </div>
    </>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logoutRequest: actions.auth.logout,
      startLoadingRequest: actions.loader.startLoading,
      stopLoadingRequest: actions.loader.stopLoading,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(Chat);
